// extracted by mini-css-extract-plugin
module.exports = {"sizeWarningWrapper":"SizeWarnings_sizeWarningWrapper__3NS3D"};